(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/result.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/result.js');

'use strict';

svs.numbergames.results.views.Result = Marionette.View.extend({
  regions() {
    let regions;
    if (this.options.model.get('productId') === 'LOTTO') {
      regions = {
        lotto1ResultRegion: '#lotto1ResultRegion',
        lotto2ResultRegion: '#lotto2ResultRegion',
        peppbubblesRegion: '#peppbubblesRegion'
      };
    } else {
      regions = {
        resultDetailRegion: '#resultDetailRegion'
      };
    }
    if (this.options.model.has('joker')) {
      regions.addonResultRegion = '#addonResultRegion';
    }
    return regions;
  },
  template(data) {
    return svs.numbergames.results.templates.result(data);
  },
  onRender() {
    if (this.model.get('productId') === 'LOTTO') {
      this.showChildView('lotto1ResultRegion', new svs.numbergames.results.views.ResultDetail({
        model: this.model.get('lotto1')
      }));
      this.showChildView('lotto2ResultRegion', new svs.numbergames.results.views.ResultDetail({
        model: this.model.get('lotto2')
      }));
      this.showChildView('peppbubblesRegion', new svs.numbergames.results.views.Peppbubbles({
        model: this.model
      }));
    } else {
      this.showChildView('resultDetailRegion', new svs.numbergames.results.views.ResultDetail({
        model: this.model
      }));
    }
    if (this.model.has('joker')) {
      this.showChildView('addonResultRegion', new svs.numbergames.results.views.ResultDetail({
        model: this.model.get('joker')
      }));
    }
  }
});

 })(window);